/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesGCSInspections.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for GCS Inspection Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, April 03, 2019 - 04:09:39 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      04/03/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const GCSInspectionList = Loadable({
    loader: () => import('../containers/GCSInspections/GCSInspectionListContainer'),
    loading: Loading,
});

export const GCSInspectionForm = Loadable({
    loader: () => import('../containers/GCSInspections/GCSInspectionEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesGCSInspections.js